import { render, staticRenderFns } from "./ActivityTimeLineItemEventSeries.vue?vue&type=template&id=06a589e4&"
import script from "./ActivityTimeLineItemEventSeries.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemEventSeries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VList,VListItem,VSkeletonLoader})
